import pointCalculatorTpl from './pointCalculator.tpl.html';
import pointCalculatorCtrl from './pointCalculator.controller';

export default {
    templateUrl: pointCalculatorTpl,
    controller: pointCalculatorCtrl,
    controllerAs: 'vm'
};
